import { UaService } from '@ecm/consumer';
import { StoreService } from '@ecm/dispatcher';

export abstract class AbstractComponent {
    /**
     * Mobile user agent flag
     * @type {boolean}
     */
    public isUserAgentMobile = false;

    /**
     * Checks if user is ONE-i eligible
     * @type {boolean}
     */
    public isOne = false;

    /**
     * AbstractComponent constructor
     * @param {UaService} uaService
     */
    public constructor(protected uaService: UaService) {}

    /**
     * On init life cycle
     */
    public init(): void {
        // check mobile user agent
        this.isUserAgentMobile = this.uaService.isMobile();
        this.isOne = StoreService.has('one') && StoreService.get('one') === true;
    }
}
